var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttentes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16668 1.6665H2.50001C2.05798 1.6665 1.63406 1.8421 1.3215 2.15466C1.00894 2.46722 0.833344 2.89114 0.833344 3.33317V16.6665C0.833344 17.1085 1.00894 17.5325 1.3215 17.845C1.63406 18.1576 2.05798 18.3332 2.50001 18.3332H12.5C12.942 18.3332 13.366 18.1576 13.6785 17.845C13.9911 17.5325 14.1667 17.1085 14.1667 16.6665V6.6665M9.16668 1.6665L14.1667 6.6665M9.16668 1.6665V6.6665H14.1667M7.50001 14.9998V9.99984M5.00001 12.4998H10",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentes);
export default __webpack_public_path__ + "static/media/attentes.797ba5f2639b2a705c05b5399256e6d5.svg";
export { ForwardRef as ReactComponent };